import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";

function Collections() {
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const sectionRef = useRef(null);
  const [showCards, setShowCards] = useState(false);

  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  const API_URL = "https://aethearia.store/superadmin/api/categories";

  // Change this folder path if your images are stored in a different folder
  const IMAGE_BASE_URL = "https://aethearia.store/superadmin/uploads/category/";

  useEffect(() => {
    fetch(API_URL)
      .then((res) => res.json())
      .then((result) => {
        if (result.status && result.data) {
          setCards(result.data);
        }
        setLoading(false);
      })
      .catch((error) => {
        console.error("Category API Error:", error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setShowCards(true);
        }
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <section
      ref={sectionRef}
      style={{
        padding: isMobile ? "20px 0" : "40px 0 0 0",
        
        width: isMobile ? "90%" : "80%",
        margin: '0 auto',
        marginTop: isMobile ? "50px" : "0",
      }}
    >
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div>
          <p
            style={{
              fontSize: "14px",
              color: "rgb(77, 67, 56)",
              marginBottom: "5px",
              textTransform: "uppercase",
            }}
          >
            Explore our
          </p>

          <h2
            style={{
              margin: 0,
              fontSize: isMobile ? "20px" : "30px",
              fontWeight: "100",
              color: "#4c144e",
            }}
          >
            Collections
          </h2>
        </div>

        <Link
          to="/shop-all"
          style={{
            textDecoration: "none",
            color: "rgb(77, 67, 56)",
            fontSize: "14px",
            fontWeight: "100",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            whiteSpace: "nowrap",
          }}
        >
          View All <FiArrowRight />
        </Link>
      </div>

      {loading ? (
        <p>Loading collections...</p>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile
              ? "repeat(2, 1fr)"
              : "repeat(5, 1fr)",
            gap: "20px",
          }}
        >
          {cards.map((card, index) => (
            <Link
              key={card.id}
             to={`/shop-all?category=${card.catslug}`}
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
              style={{
                width: "100%",
                position: "relative",
                overflow: "hidden",
                cursor: "pointer",
                // borderRadius: "5px",
                textDecoration: "none",

                opacity: showCards ? 1 : 0,
                transform: showCards ? "translateY(0)" : "translateY(120px)",

                transition: `
                  transform 0.9s cubic-bezier(.22,1,.36,1),
                  opacity 0.9s ease
                `,
                transitionDelay: `${index * 0.2}s`,
              }}
            >
              <img
                src={IMAGE_BASE_URL + card.catimg}
                alt={card.catname}
                style={{
                  width: "100%",
                  height: isMobile ? "260px" : "344px",
                  objectFit: "cover",
                  transition: "0.5s ease",
                  borderRadius: "5px",
                  transform:
                    hoveredIndex === index ? "scale(1.05)" : "scale(1)",
                }}
              />

              <div
                style={{
                  position: "absolute",
                  inset: 0,
                  background:
                    "linear-gradient(to top, rgba(0,0,0,0.75), rgba(0,0,0,0.2))",

                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "flex-end",

                  alignItems: isMobile ? "flex-start" : "center",
                  textAlign: isMobile ? "left" : "center",
                  padding: isMobile ? "15px" : "0",
                  gap: "6px",
                }}
              >
                <h3
                  style={{
                    color: "white",
                    fontWeight: "100",
                    fontSize: "14px",
                    margin: "0",
                    marginBottom: "10px",
                    textTransform: "capitalize",
                  }}
                >
                  {card.catname}
                </h3>

                {/* <p
                  style={{
                    color: "white",
                    fontWeight: "400",
                    letterSpacing: "1px",
                    margin: "0",
                    fontSize: "14px",
                    marginBottom: "20px",
                  }}
                >
                  {card.total_products} Products
                </p> */}
              </div>
            </Link>
          ))}
        </div>
      )}
    </section>
  );
}

export default Collections;